import { render, staticRenderFns } from "./surchargesModal.vue?vue&type=template&id=66d25016&"
import script from "./surchargesModal.vue?vue&type=script&lang=js&"
export * from "./surchargesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports